import { render, staticRenderFns } from "./Noty.vue?vue&type=template&id=52064c6a&"
import script from "./Noty.vue?vue&type=script&lang=ts&"
export * from "./Noty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/app/components/base/Icon.vue').default})
